export default "__VITE_ASSET__DJM95cW2__"